import { useEffect, useState } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { MapPin, Users, GraduationCap } from "lucide-react";
import { api } from "@/lib/api";

function Counter({ value }) {
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (v) => Math.round(v).toLocaleString("id-ID"));
  useEffect(() => {
    const controls = animate(mv, value, { duration: 1.6, ease: [0.16, 1, 0.3, 1] });
    return controls.stop;
  }, [value, mv]);
  return <motion.span>{rounded}</motion.span>;
}

export function HeroCounters() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/public/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  const items = [
    { icon: MapPin, label: "Jumlah Kwarran", value: stats ? stats.per_kwarran.length : 0, tone: "bg-[#B85C38]", testid: "hero-count-kwarran" },
    { icon: Users, label: "Jumlah Peserta Didik", value: stats ? stats.total_pramuka : 0, tone: "bg-[#4A2E2B]", testid: "hero-count-peserta-didik" },
    { icon: GraduationCap, label: "Jumlah Pembina & Pelatih", value: stats ? stats.total_pembina + stats.total_pelatih : 0, tone: "bg-[#E5A93C]", testid: "hero-count-pembina-pelatih" },
  ];

  return (
    <div className="mt-10 grid grid-cols-3 gap-3 sm:gap-4" data-testid="hero-counters">
      {items.map((it, i) => {
        const Icon = it.icon;
        return (
          <motion.div key={it.label} data-testid={it.testid}
            initial={{ opacity: 0, y: 24, scale: 0.94 }} animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.35 + i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ y: -4 }}
            className="relative overflow-hidden bg-white/80 backdrop-blur rounded-2xl border border-[#E5DFD7] shadow-sm p-4">
            <motion.div className={`absolute -top-6 -right-6 h-16 w-16 rounded-full ${it.tone} opacity-15`}
              animate={{ scale: [1, 1.25, 1] }} transition={{ duration: 3.5, repeat: Infinity, delay: i * 0.6 }} />
            <div className={`h-8 w-8 rounded-lg ${it.tone} flex items-center justify-center mb-3`}>
              <Icon className="h-4 w-4 text-white" />
            </div>
            <div className="font-display text-2xl sm:text-3xl font-extrabold text-[#1F1917] leading-none tabular-nums">
              <Counter value={it.value} />
            </div>
            <div className="mt-1.5 text-[10px] sm:text-xs uppercase tracking-widest font-bold text-[#8C827A] leading-tight">{it.label}</div>
          </motion.div>
        );
      })}
    </div>
  );
}
